import { ClassNameOnlyProps } from 'module/types/common';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { ShimmerText } from 'module/ui/components/atoms/shimmer-text';
import { Label01 } from 'module/ui/components/styles';
import { FC } from 'react';
import { PropsWithChildren } from 'react';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface SectionTitleProps extends ClassNameOnlyProps {
  title: ReactNode;
  icon?: ReactNode;
  loading?: boolean;
}
const Icon = styled(FontAwesomeIcon).attrs({ size: 12 })`
  color: var(--icon-disabled);
`;

export const Label = styled.span`
  ${Label01};
  opacity: 0.7;
`;
export const Title = styled(CenterAlignedBox).attrs({ gap: 4 })`
  ${Label01};
`;
type Props = {
  title: ReactNode;
  icon?: ReactNode;
  loading?: boolean;
  className?: string;
};

const SectionTitleComponent: FC<Props> = (props) => {
  return (
    <Title className={props.className}>
      {props.icon}
      <Label>
        <ShimmerText loading={props.loading}>{props.title}</ShimmerText>
      </Label>
    </Title>
  );
};

type SectionTitle = FC<PropsWithChildren<SectionTitleProps>> & {
  Icon: typeof Icon;
};
const SectionTitle = SectionTitleComponent as SectionTitle;

SectionTitle.Icon = Icon;

export { SectionTitle };
